<template>
  <div>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">
            {{ this.pageTitle }}
          </h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                outlined
                :label="this.$t('columns.effectivefrom')"
                type="date"
                dense
                v-model="formData.startdate"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                outlined
                :label="this.$t('columns.effectiveuntil')"
                type="date"
                dense
                v-model="formData.enddate"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="mb-4">
            <app-parameter
              v-on:input="onFilterChange"
              v-bind:parentObject="{
                filter: this.showFilter,
              }"
            />
          </div>

          <v-row align="center">
            <div class="pt-5 col-sm-8 col-8">
              <v-btn
                color="success"
                style="width: 100px"
                @click="processHandler"
              >
              {{$t('button.process')}}
              </v-btn>
            </div>
          </v-row>
        </v-container>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import FilterParameter from "../../../components/common/FilterParameter";

export default {
  components: {
    "app-error": ErrorDialog,
    "app-parameter": FilterParameter,
  },

  data() {
    return {
      pageTitle: this.$t('setupmappingprocess.groupmappingprocess'),
      pageTitleValue: "",
      formData: {
        startdate: null,
        enddate: null,
        staffid: null,
        compnyid: null,
        brchid: null,
        divnid: null,
        deptid: null,
        sectioid: null,
        unitid: null,
        grdid: null,
        emptypeid: null,
        positionid: null,
        gtypeid: null,
        userid: this.$store.getters.userId,
      },

      showFilter: {
        staffid: true,
        companyid: true,
        branchid: true,
        divisionid: true,
        departmentid: true,
        sectionid: true,
        unitid: true,
        gradeid: true,
        employmenttypeid: true,
        positionid: true,
        grpmapid: true,
      },

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },
    onFilterChange(params) {
      this.formData.staffid    = params.staffid          || null;
      this.formData.compnyid   = params.companyid        || null;
      this.formData.brchid     = params.branchid         || null;
      this.formData.divnid     = params.divisionid       || null;
      this.formData.deptid     = params.departmentid     || null;
      this.formData.sectioid   = params.sectionid        || null;
      this.formData.unitid     = params.unitid           || null;
      this.formData.grdid      = params.gradeid          || null;
      this.formData.emptypeid  = params.employmenttypeid || null;
      this.formData.positionid = params.positionid       || null;
      this.formData.gtypeid    = params.grpmapid         || null;
    },
    processHandler() {
      const vm = this;

      //   if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
      //     return false;
      //   }

      this.$store.dispatch('post', {url: "/mapping/process", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$dialog.alert(this.$t('setupmappingprocess.processcompleted')).then((dialog) => {
              console.log(dialog);
            });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },
};
</script>